<!--todo  -->
<template>
  <div v-if="prescriptionDetail.prescriptionAuditTime">
    <!-- <div class="split-line"></div> -->
    <h3>审方</h3>
    <el-row v-if="prescriptionDetail.prescriptionAuditTime">
      <el-col :span="24">
        <span>
          {{ prescriptionDetail.prescriptionAuditTime | parseTime }}&nbsp;&nbsp;&nbsp;&nbsp;{{
            prescriptionDetail.prescriptionAuditorName
          }}&nbsp;&nbsp;&nbsp;&nbsp;{{
            prescriptionDetail.prescriptionAuditorStatus | parsePrescriptionStatus
          }}&nbsp;&nbsp;&nbsp;&nbsp;备注:{{ prescriptionDetail.prescriptionAuditorMemo }}
        </span>
      </el-col>
    </el-row>

    <el-row v-if="prescriptionDetail.prescriptionReauditTime">
      <el-col :span="24">
        <span>
          {{ prescriptionDetail.prescriptionReauditTime | parseTime }}&nbsp;&nbsp;&nbsp;&nbsp;{{
            prescriptionDetail.prescriptionReauditorName
          }}&nbsp;&nbsp;&nbsp;&nbsp;{{
            prescriptionDetail.prescriptionReauditorStatus | parsePrescriptionStatus
          }}&nbsp;&nbsp;&nbsp;&nbsp;备注:{{ prescriptionDetail.prescriptionReauditorMemo }}
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'prescriptionAudit',
  props: {
    prescriptionDetail: {}
  },
  methods: {}
};
</script>

<style lang="scss"></style>
